import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Reveal } from './Reveal';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-steel-950 px-6 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-54" data-mp="1bmd8ncjfgm7p">
      <div className="mx-auto max-w-3xl" data-id="element-55" data-mp="1gk57yrmejalx">
        <h2 id="faq-title" className="text-center font-display text-3xl font-bold uppercase tracking-tight text-ink-50 sm:text-4xl" data-id="element-56" data-mp="249g4fwwpyiu9">
          Frequently asked questions
        </h2>

        <ul className="mt-8 grid gap-2.5" data-id="element-57" data-mp="28cm6escstnux">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          return <Reveal as="li" key={question} index={index} data-id="element-58" data-mp="1zgmvsxy4qqcw" data-mpi={index}>
                <div className="overflow-hidden border border-white/[0.07] bg-steel-900" data-id="element-59" data-mp="2n70tp53ebjfe">
                  <h3 data-id="element-60" data-mp="2rz0n0eoyne30">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-4 text-left font-display text-lg font-semibold uppercase tracking-wide text-ink-50 transition-colors duration-150 ease-out hover:text-ember-400" data-id="element-61" data-mp="2rzk6hzu9eaj5">
                      {question}
                      {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-ember-400" aria-hidden="true" data-id="element-62" data-mp="19u521ksxxnwi" /> : <PlusIcon className="h-4 w-4 shrink-0 text-ink-500" aria-hidden="true" data-id="element-63" data-mp="1oj17rb7iyoty" />}
                    </button>
                  </h3>
                  <div className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-64" data-mp="1jjeux2vlzalo">
                    <div className="overflow-hidden" data-id="element-65" data-mp="1skv3r66rz4ns">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-ink-400" data-id="element-66" data-mp="1sledhzm9umqq">{answer}</p>
                    </div>
                  </div>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}